import { reducers } from '../../reducers';
import { IApplicationContext } from '../../types/applicationContext';
import { IApplicationState, TReduxActions } from '../../types/redux';
import { makeCreateStore } from './makeCreateStore';

export const createReduxStore = makeCreateStore<IApplicationState, IApplicationContext, TReduxActions>({
  name: 'header-frontend',
  reducer: reducers,
});
